/* Global defined types */

export const AccountRoles = [
  {
    id: 1,
    name: 'Normal user',
  },
  {
    id: 3,
    name: 'Admin',
  },
  {
    id: 2,
    name: 'Owner',
  },
]
